import useMediaQuery from '@eversports/klimt-design-components/use-media-query'
import useTheme from '@eversports/klimt-design-components/use-theme'
import Box from '@eversports/klimt-primitives/legacy/Box'
import Stack from '@eversports/klimt-primitives/legacy/Stack'
import { useParams } from 'react-router-dom'

import { useParticipationSectionMatchQuery } from '../../../graphql'
import Card from '../components/Card'
import { VALID_BALLSPORT_MATCH_STATES } from '../Match.constants'

import CallToAction from './CallToAction'
import Disclaimer from './Disclaimer'
import OrganizerNotes from './OrganizerNotes'
import Participants from './Participants'

const ParticipationSection = () => {
  const theme = useTheme()
  const { id } = useParams<{ id: string }>()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
  const { data } = useParticipationSectionMatchQuery({ variables: { matchId: id } })

  if (!data) {
    return null
  }

  if (VALID_BALLSPORT_MATCH_STATES.includes(data.match.state)) {
    return (
      <Card sx={{ p: 4 }}>
        <Stack gap={5}>
          {!isMobile ? (
            <Stack direction="row">
              <Stack gap={5} flex={3}>
                <Disclaimer />
                <OrganizerNotes />
              </Stack>
              <Box sx={{ alignSelf: 'self-start', marginLeft: 3, flex: 2, display: { xs: 'none', sm: 'initial' } }}>
                <CallToAction />
              </Box>
            </Stack>
          ) : (
            <OrganizerNotes />
          )}
          <Participants />
        </Stack>
      </Card>
    )
  }

  return null
}

export default ParticipationSection
